/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Varietal_PlaceholderInputs */

const en_varietal_placeholder = /** @type {(inputs: Varietal_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Caturra`)
};

const es_varietal_placeholder = /** @type {(inputs: Varietal_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Caturra`)
};

/**
* | output |
* | --- |
* | "e.g. Caturra" |
*
* @param {Varietal_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const varietal_placeholder = /** @type {((inputs?: Varietal_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Varietal_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_varietal_placeholder(inputs)
	return es_varietal_placeholder(inputs)
});